import React from 'react'
import "./Header.css"
import {NavLink} from 'react-router-dom'

function Header(props) {
  return (
    <>
    <div className='header-bg'>
    <nav className="navbar navbar-expand-lg col">
  <div className="container-fluid">
    <a className="navbar-brand" href="/">Lacks</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav  mb-2 mb-lg-0 d-flex align-items-center">
      <button className='rounded-circle drk-m' onClick={props.toggle} style={{background:"transperent"}} ><i className='fa fa-moon fs-3' ></i></button>
        
        <li className="nav-item">
          <NavLink className="nav-link" to="/contact">About Me</NavLink>
        </li>
        
        
      </ul>
    </div>
  </div>
</nav>
{/* HEADER CONTENT  */}
<div className="heading">
    <h1 className='hed'>The best free stock photos, royalty free images & videos shared by creators.</h1>
    <div className="button">
<a href="#srch"><button className='btn-now'>Search Now!</button></a>
</div>
</div>

</div>
    </>
  )
}

export default Header